import React, { useState, useEffect } from "react";
import { getDailySheet } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message, Button } from "antd";
import Example from "./calling.js";
import SideBar from "../../sidebar/sideBar";
import { deleteSale, getAlert } from "../../../api/endpoints/alert.js";

const DailySheet = () => {
  const { access_token } = useSelector(authSelector);
  const [dateEntered, setDateEntered] = useState("");
  const [loading, setLoading] = useState(false);

  const setDate = (e) => {
    setDateEntered(e.target.value);
  };
  console.log(dateEntered);
  const [itemsQueue, setItemsQueue] = useState([]);

  // const editHandler = async (e) => {
  //   if (!dateEntered) return message.error("Please type date !");
  //   let data = {
  //     enteredOn: dateEntered,
  //   };
  //   const results = await getDailySheet(data, access_token);
  //   console.log(results.data.length, "ressaaaaa");
  //   if (results.data.length === 0) {
  //     message.error("No Record Found in this date");
  //   }
  //   if (results.success) {
  //     const payload = results.data.reduce((acc, curr) => {
  //       return [
  //         ...acc,
  //         {
  //           enteredOn: curr.enteredOn,
  //           itemCode: curr.itemCode,
  //           itemName: curr.itemName,
  //           saleRate: Number(curr.saleRate),
  //           purchaseRate: Number(curr.purchaseRate),
  //           quantity: Number(curr.quantity),
  //           partyName: curr.partyName,
  //           partyId: Number(curr.partyId),
  //           shift: Number(curr.shift),
  //           nozelNumber: curr.nozelNumber,
  //           meterStarting: Number(curr.meterStarting),
  //           meterEnding: Number(curr.meterEnding),
  //           tankNumber: curr.tankNumber,
  //           mmOpening: Number(curr.mmOpening),
  //           quantityOpening: Number(curr.quantityOpening),
  //           mmClosing: Number(curr.mmClosing),
  //           quantityClosing: Number(curr.quantityClosing),
  //           generalLedgerCode: Number(curr.generalLedgerCode),
  //           generalLedgerDescription: curr.generalLedgerDescription,
  //           description: curr.description,
  //           purchaseVoucherNo: curr.purchaseVoucherNo,
  //           voucherNumber: curr.voucherNumber,
  //           cheqNumber: curr.cheqNumber,
  //           debit: curr.debit,
  //           credit: curr.credit,
  //           siteId: curr.siteId,
  //           printOrder: curr.printOrder,
  //           itemDescription: curr.itemDescription,
  //           meterCheck: curr.meterCheck,
  //           balanceQty: Number(curr.balanceQty),
  //           nozelOrder: Number(curr.nozelOrder),
  //         },
  //       ];
  //     }, []);
  //     setItemsQueue(payload);
  //     //   setItemsQueue(results.data);
  //     //   if (results.data.length > 0) {
  //     //     navigate("/stockBalence");
  //     //   }
  //   } else {
  //     message.error(results.message);
  //   }
  // };

  const editHandler = async (e) => {
  if (!dateEntered) return message.error("Please type date !");

  const data = {
    enteredOn: dateEntered,
  };

  try {
    setLoading(true);

    const results = await getDailySheet(data, access_token);

    console.log(results.data.length, "ressaaaaa");

    if (results.data.length === 0) {
      return message.error("No Record Found in this date");
    }

    if (results.success) {
      const payload = results.data.map((curr) => ({
        enteredOn: curr.enteredOn,
        itemCode: curr.itemCode,
        itemName: curr.itemName,
        saleRate: Number(curr.saleRate),
        purchaseRate: Number(curr.purchaseRate),
        quantity: Number(curr.quantity),
        partyName: curr.partyName,
        partyId: Number(curr.partyId),
        shift: Number(curr.shift),
        nozelNumber: curr.nozelNumber,
        meterStarting: Number(curr.meterStarting),
        meterEnding: Number(curr.meterEnding),
        tankNumber: curr.tankNumber,
        mmOpening: Number(curr.mmOpening),
        quantityOpening: Number(curr.quantityOpening),
        mmClosing: Number(curr.mmClosing),
        quantityClosing: Number(curr.quantityClosing),
        generalLedgerCode: Number(curr.generalLedgerCode),
        generalLedgerDescription: curr.generalLedgerDescription,
        description: curr.description,
        purchaseVoucherNo: curr.purchaseVoucherNo,
        voucherNumber: curr.voucherNumber,
        cheqNumber: curr.cheqNumber,
        debit: curr.debit,
        credit: curr.credit,
        siteId: curr.siteId,
        printOrder: curr.printOrder,
        itemDescription: curr.itemDescription,
        meterCheck: curr.meterCheck,
        balanceQty: Number(curr.balanceQty),
        nozelOrder: Number(curr.nozelOrder),
      }));

      setItemsQueue(payload);

      // If needed
      // navigate("/stockBalence");
      // generatePDF(payload);
    } else {
      message.error(results.message);
    }
  } catch (err) {
    console.error(err);
    message.error("Something went wrong!");
  } finally {
    setLoading(false);
  }
};

  const clearState = () => {
    setItemsQueue([]);
  };

  const chkAlert = async () => {
    try {
      const getCurrentDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        return `${year}/${month}/${day}`;
      };

      const getD = getCurrentDate();
      let data = {
        enteredOn: getD,
      };

      const results = await getAlert(data, access_token);

      if (Array.isArray(results.data)) {
        results.data.forEach((alert) => {
          const handleButtonClick = async () => {
            console.log(alert.id); // Replace with your desired action
            const results = await deleteSale(alert.id, access_token);
          };

          message.info({
            content: (
              <div>
                {`Amount Notification ${alert.description}, Amount: ${alert.amount}`}
                <Button
                  type="primary"
                  size="small"
                  onClick={handleButtonClick}
                  style={{ marginLeft: "10px" }}
                >
                  Delete
                </Button>
              </div>
            ),
            className: "custom-message",
          });
        });
      } else if (results.data) {
        const handleButtonClick = async () => {
          const results = await deleteSale(results.data.id, access_token);
        };

        message.info({
          content: (
            <div>
              {`${results.data.description}, ${results.data.amount}`}
              <Button
                type="primary"
                size="small"
                onClick={handleButtonClick}
                style={{ marginLeft: "10px" }}
              >
                Action
              </Button>
            </div>
          ),
          className: "custom-message",
        });
      }
    } catch (error) {
      console.error("Error fetching alert:", error);
    }
  };

  useEffect(() => {
    chkAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log(itemsQueue, "payy");
  return (
    <>
      {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && <Example item={itemsQueue} />}
          </div>
          <div className="pb-3 flex justify-center">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              onClick={clearState}
            >
              Exit
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <div className="flex justify-center mt-32">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className=" text-white">Daily Sheet</h1>
                  </div>
                  <div className="flex flex-col  h-40 content-center items-center justify-items-center justify-evenly">
                    <div>
                      <label className="text-white" for="fname">
                        Date:
                      </label>
                      <input
                        type="date"
                        className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                        onChange={setDate}
                      />
                    </div>
                    <div>
                      {/* <button 
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        onClick={editHandler}
                      >
                        View
                      </button> */}
                       <button  
                    className={`bg-blue-500 text-white mt-2 ml-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                    onClick={editHandler}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "View"}
                  </button>
                      <button className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded">
                        clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DailySheet;
